module.exports = __webpack_public_path__ + "static/img/logo-white.97dffa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/logo-white.png
// module id = Csea
// module chunks = 1